import React from "react";
import {
  ChevronLeft,
  ChevronRight,
  ChevronsLeft,
  ChevronsRight,
} from "lucide-react";
import Button from "../ui/button";

const MonthView = ({
  year,
  month,
  tradeData,
  onDayClick,
  selectedDay,
  onPrevMonth,
  onNextMonth,
  onPrevYear,
  onNextYear,
  months,
}) => {
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const firstDay = new Date(year, month, 1).getDay();

  const isWeekend = (index) =>
    (index + firstDay) % 7 === 0 || (index + firstDay) % 7 === 6;

  const hasTrade = (dayData) => {
    return dayData && dayData.trades > 0;
  };

  return (
    <div className="p-4 mb-4 rounded-lg dark:bg-slate-800 bg-white text-slate-400">
      <div className="flex justify-between items-center mb-4">
        <Button onClick={onPrevYear} className="mr-2">
          <ChevronsLeft size={20} />
        </Button>
        <Button onClick={onPrevMonth} className="mr-2">
          <ChevronLeft size={20} />
        </Button>
        <h3 className="mx-2">
          {months[month]} {year}
        </h3>
        <Button onClick={onNextMonth} className="ml-2">
          <ChevronRight size={20} />
        </Button>
        <Button onClick={onNextYear} className="ml-2">
          <ChevronsRight size={20} />
        </Button>
      </div>
      <div className="grid grid-cols-7 gap-1 text-slate-400">
        {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day) => (
          <div
            key={day}
            className="text text-center"
          >
            {day}
          </div>
        ))}
        {Array.from({ length: firstDay }).map((_, i) => (
          <div key={`empty-${i}`} className="h-24"></div>
        ))}
        {Array.from({ length: daysInMonth }).map((_, i) => {
          const day = i + 1;
          const dayData = tradeData[day] || { pl: 0, trades: 0 };
          const isProfit = dayData.pl > 0;
          const isSelected = selectedDay === day;
          const hasTradeData = hasTrade(dayData);

          return (
            <div
              key={day}
              className={`h-24 p-2 border border-slate-500 rounded-md cursor-pointer ${
                isWeekend(i)
                  ? "dark:bg-black bg-black"
                  : "dark:bg-black bg-black"
              } ${
                isSelected
                  ? "dark:bg-slate-800 bg-slate-200"
                  : "dark:bg-slate-700 bg-white"
              }`}
              onClick={() => onDayClick(day)}
            >
              <div
                className={`font-bold ${
                  hasTradeData
                    ? isProfit
                      ? "text-green-500"
                      : "text-red-500"
                    : ""
                }`}
              >
                {day}
              </div>
              {hasTradeData && (
                <>
                  <div className="max-md:hidden ">
                    <p
                      className={`text-sm ${isProfit ? "text-green-500" : "text-red-500"}`}>
                      £{dayData.pl.toFixed(2)}
                    </p>
                    <p className="text-xs">[{dayData.trades} Trades]</p>
                  </div>
                  <div className="lg:hidden">
                  <p
                    className={`text-xs ${isProfit ? "text-green-500" : "text-red-500"}`}>
                    {dayData.pl.toFixed(2)}
                  </p>
                  <p className="text-xs text-slate-400 dark:text-white">[{dayData.trades}]</p>
                  </div>
                </>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MonthView;
